// /* eslint-disable @typescript-eslint/quotes */
// /* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: true,
  appname: "DEVELOP N1",
  // url_xavier: "http://190.154.254.138:82/api/api/listadoproductos.php",
  // url_web_services_path: "http://localhost:8000/",
  // url_web_services_path: "http://192.168.18.61:8000/",
  url_web_services_path: "https://mrnutsa.giro.com.ec/mrnutsapi/",
  // url_web_services_path: "http://3.5.2.61:8000/",
  // url_web_services_path: "http://3.5.2.52:8000/",
  // url_web_services_path: "http://192.168.1.11:8000/",
  // url_web_services_path: "http://192.168.0.104:8000/",
  // url_web_services_path: "http://192.168.33.137:8000/",
  // la url de la linea 11 era porque tenia otro proyecto pero ese proyecto es deprecated
  // url_web_services_path: "http://localhost:8000/api/",
  // url_products_xavier: "http://192.168.0.120:8080/api/test/admin/products/products.php",
  // url_products_xavier: "https://giro.com.ec/api/api/test/admin/products/products.php",
  // url_products_xavier: "https://abago.com.ec/api/api/test/admin/products/products.php",
};

/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/naming-convention */
// export const environment = {
//   production: true,

//   // 🔹 Dirección inicial por defecto (fallback)
//   url_web_services_path: "http://3.5.2.57:8000/",

//   // 🔹 Lista de posibles servidores Django (puedes agregar más)
//   knownServers: [
//     'http://192.168.18.61:8000/',
//     'http://192.168.1.11:8000/',
//     'http://3.6.5.1:8000/',
//     'http://3.5.2.57:8000/',
//     'http://localhost:8000/'
//   ],

//   // 🔹 Otros servicios externos
//   url_products_xavier: "https://giro.com.ec/api/api/test/admin/products/products.php",
// };
